import { isAllowedProtocol, parseChangeUrl } from './parseChangeUrl';

// Exact hosts, not wildcards
const SHORT_LINK_HOSTS = new Set(['c.org', 'www.c.org', 'staging.c.org', 'chng.it', 'www.chng.it', 'staging.chng.it']);

/**
 * Whether `url` is on a Change short-link host. Short links are trusted: they're left unwrapped in
 * UGC links and are a valid direct redirect target for vanity URLs. They are not a "page" though
 * (see `isChangePageUrl`), so callers that need an actual Change.org page must not accept them.
 *
 * `baseUrl` must be a Change app host or this returns `false`. Never throws.
 */
export function isChangeShortUrl(url: string, { baseUrl }: { baseUrl: string }): boolean {
	const parsed = parseChangeUrl(url, baseUrl);
	return (
		!!parsed && isAllowedProtocol(parsed.parsedUrl, parsed.parsedBaseUrl) && SHORT_LINK_HOSTS.has(parsed.parsedUrl.host)
	);
}
